<template>
  <div>
    <div v-if="!isDev()">
      <h1>Shift Reconciliation</h1>
      <p>Dev only, at the moment.</p>
    </div>
    <div v-if="isDev()">
      <div class="pane-group">
          <div class="pane-sm" >
          
          <h5>Select Shift</h5>
          <nav-item v-for="(shift, i) in shifts" v-on:click="selectShift(i)" 
          :class="i === selectedShift ? 'active' : ''" :key="i">
            {{moment(shift.from).format('ddd YYYY-MM-DD hh:mm a')}}
          </nav-item>
          
          
          
        </div>
        <div class="pane">
          <h1>Shift Reconciliation</h1>

          <p>From: {{shifts[selectedShift].from}}</p>
          <p>To: {{shifts[selectedShift].to}}</p>


          <div style="width:400px">
            <BasicTableComponent :list="sales" :formatters="salesFormatters" :titles="salesTitles"/>
          </div>

          <br>
          <div style="width:400px">
            <BasicTableComponent :list="pos" :formatters="salesFormatters" :titles="salesTitles"/>
          </div>

          <br>
          <h3>Fuel Sales</h3>
          <div style="width:400px">
            <BasicTableComponent :list="totalizers" :formatters="salesFormatters" :titles="salesTitles"/>
          </div>

          <br>
          <h3>Fuel Sales - From Fuel Accum 2</h3>
          <div style="width:400px">
            <BasicTableComponent :list="fuelSales" :formatters="salesFormatters" :titles="salesTitles"/>
          </div>
          <div v-if="fuelSales.length > 0">
            Rebate:{{ num(fuelSales[fuelSales.length - 1].litres * -0.04)}}
            Total: {{ num(fuelSales[fuelSales.length - 1].dollars + (fuelSales[fuelSales.length - 1].litres * -0.04))}}
          </div>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Intro',
  data: function(){
    return {
      shifts: [],
      selectedShift: '',
      location: 'RCGB',
      sales:[],
      pos:[],
      totalizers:[],
      fuelSales:[],
      salesFormatters: {},
      salesTitles: {}
    }
  }, 
  async created () {
    this.getShifts()
  },
  mounted(){
  },
  methods: {
    isDev: ()=>localStorage.isDev === "true",
    getShifts: async function(){
      let response = await i_axios.post('/getShifts', { location:this.location, from:'2018-12-10', to:'2019-01-25' })
      this.shifts = response.data;
      this.selectShift(0);
    },
    selectShift: async function(i){
      this.selectedShift = i
      let location = this.location;
      let from = this.shifts[i].from;
      let to = this.shifts[i].to;
      let id = this.shifts[i].id;
      this.sales=[];
      this.pos=[];
      this.totalizers=[];
      this.fuelSales=[];
      i_axios.post('/getSalesSum', { location, from, to }).then((r)=>{
        this.sales = r.data;  
      })

      i_axios.post('/getPosSum', { location, from, to }).then((r)=>{
        let total = {};
        total.location = 'total'
        total.settle_amount = r.data.reduce((acc, cur)=>acc+parseFloat(cur.settle_amount),0)
        r.data.push(total)
        this.pos = r.data;  
      })

      i_axios.post('/getTotalizers', { location, from, to }).then((r)=>{
        let subtotal = {}
        let grandTotal = {}
        Object.keys(r.data[0]).forEach(k=>{
          subtotal[k] = r.data.reduce((acc, cur)=>acc+cur[k], 0)
        })
        subtotal.title = 'Subtotal'
        grandTotal.title = 'Grand Total'
        grandTotal.litre_1 = 0;
        grandTotal.dollar_1 = 0;
        Object.keys(r.data[0]).forEach(k=>{
          grandTotal.litre_1 += k.startsWith('litre') ? subtotal[k] : 0
          grandTotal.dollar_1 += k.startsWith('dollar') ? subtotal[k] : 0
        })

        r.data.push(subtotal)
        r.data.push(grandTotal)
        
        this.totalizers = r.data;  
      })

      i_axios.post('/getFuelSales', { location, from, to, id }).then((r)=>{
        this.fuelSales = r.data;  
      })
    },
    //This is probably not the right way to use moment
    moment: function(d){
      return moment(d.split('Z')[0])
    }, 
    num: function(value){
      return numeral(value).format('0,0.00')
    }
  },
}
</script>

<style>
p {
    -webkit-touch-callout: all;
    -webkit-user-select: all;
    -khtml-user-select: all;
    -moz-user-select: all;
    -ms-user-select: all;
    user-select: all;
}
</style>
